import { createContext } from 'react';

import { PartnerConfigContextType } from './PartnerConfigContext.types';

export const PartnerConfigContext = createContext<PartnerConfigContextType>(undefined);
